"use client";

import * as React from "react";
import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { HeroPost } from "./heroPost";
import { IPost } from "@/types/post";
import { RichTextEntry } from "../richText/generic";
import { PostSummary } from "../richText/summary";

export const PostSingle = ({ entry }: { entry: IPost }) => {
  const data = useContentfulLiveUpdates(entry, { locale: "fr" });
  // const data = entry;
  if (!data || !entry) return null;
  return (
    <ContentfulLivePreviewProvider
      locale="fr"
      enableInspectorMode={true}
      enableLiveUpdates={true}
      debugMode={true}
    >
      <div className="xl:pl-14 bg-line-pattern bg-[length:600px_600px] bg-repeat ">
        <div className="xl:border-l xl:border-l-gray-200 ">
          <HeroPost entry={data} />
          <div className="bg-white ">
            <div className="grid xl:grid-cols-12 ">
              <div className="xl:col-span-4 hidden xl:block">
                <div className="sticky top-10">
                  <div className="px-6 xl:px-16 space-y-10 border-t xl:border-t-0 pt-10 xl-pt-0">
                    {data.body?.json && (
                      <PostSummary richTextDocument={data.body.json} />
                    )}
                  </div>
                </div>
              </div>
              <div className="xl:col-span-8 border-l px-10 py-12 xl:py-12 xl:px-16">
                {data.body?.json && (
                  <div
                    {...ContentfulLivePreview.getProps({
                      entryId: entry.sys.id,
                      fieldId: "body",
                    })}
                  >
                    <RichTextEntry
                      richTextDocument={data.body?.json}
                      links={data.body.links}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* OPERATION BODY
          <pre>{JSON.stringify(data, null, 2)}</pre> */}
          </div>
        </div>
      </div>
    </ContentfulLivePreviewProvider>
  );
};
